export default __webpack_public_path__ + "static/1-fd6f42d5e68a038b0ee0d8dc5d7b6712.gif";